import { API_BASE as SBIN_API_BASE } from "./base";
const API_BASE = SBIN_API_BASE;

async function handleResponse(res) {
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.detail || "Unable to complete request");
  }
  return body;
}

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export async function createJoinRequest(token, salonId, message) {
  const res = await fetch(`${API_BASE}/salon-join-requests`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ salon_id: salonId, message }),
  });
  return handleResponse(res);
}

export async function listMine(token) {
  const res = await fetch(`${API_BASE}/salon-join-requests/mine`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(res);
}

export async function listPending(token, salonId, options = {}) {
  const search = new URLSearchParams();
  if (salonId) {
    search.set("salon_id", String(salonId));
  }
  if (options.includeRecent) {
    search.set("include_recent", "true");
  }
  if (options.recentDays) {
    search.set("recent_days", String(options.recentDays));
  }
  const params = search.toString() ? `?${search.toString()}` : "";
  const res = await fetch(`${API_BASE}/salon-join-requests/pending${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(res);
}

export async function approveRequest(token, requestId, role = "technician") {
  const res = await fetch(`${API_BASE}/salon-join-requests/${requestId}/approve`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ role }),
  });
  return handleResponse(res);
}

export async function rejectRequest(token, requestId) {
  const res = await fetch(`${API_BASE}/salon-join-requests/${requestId}/reject`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(res);
}

export async function cancelJoinRequest(token, requestId) {
  const res = await fetch(`${API_BASE}/join-requests/${requestId}/cancel`, {
    method: "POST",
    headers: authHeaders(token),
  });
  return handleResponse(res);
}

export async function managerCancelJoinRequest(token, requestId) {
  const res = await fetch(`${API_BASE}/manager/join-requests/${requestId}/cancel`, {
    method: "POST",
    headers: authHeaders(token),
  });
  return handleResponse(res);
}
